
import draggable, {MoveEvent} from 'vuedraggable';
import {Component, Vue, Prop, Watch} from "vue-property-decorator";

@Component({
  components: {
    draggable,
  },
})
export default class CreateSurveyQuestions extends Vue {

  @Prop({required: true})
  survey!: ISurvey;

  questions: ISurveyQuestion[] = [];

  @Watch('questions')
  onQuestionsChange() {
    this.$emit('change', this.questions);
  }

  @Watch('survey.id')
  onSurveyChange() {
    this.questions = this.survey.questions;
  }

  addQuestion() {
    this.questions.push({
      id: null,
      surveyId: this.survey.id,
      sort: this.questions.length + 1,
      text: '',
      answerType: undefined,
      predefinedAnswers: [],
      answers: [],
    });
  }

  removeQuestion(index: number) {
    this.questions.splice(index, 1);
  }

  copyQuestion(index: number) {
    const question = this.questions[index];
    const duplicate = {
      id: null,
      surveyId: this.survey.id,
      text: question.text,
      sort: this.questions.length + 1,
      answerType: question.answerType,
      predefinedAnswers: JSON.parse(JSON.stringify(question.predefinedAnswers)),
      answers: [],
    };
    this.questions.push(duplicate);
  }

  validateForm(formRef: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.$forceUpdate();
      this.$nextTick(() => {
        const form = this.$refs[formRef] as HTMLFormElement;
        form.classList.add('was-validated');
        resolve(form.checkValidity());
      });
    });
  }

  updateQuestionOrder() {
    this.questions.forEach((question, index) => {
      question.sort = index + 1;
    });
  }

  // Predefined Answers
  addAnswer(question: ISurveyQuestion) {
    if (!question.predefinedAnswers) {
      this.$set(question, 'predefinedAnswers', []);
    }
    const answer = {
      id: null,
      surveyQuestionId: question.id,
      text: '',
      sort: question.predefinedAnswers.length + 1,
    } as ISurveyQuestionAnswer;
    question.predefinedAnswers.push(answer);
  }

  removeAnswer(question: ISurveyQuestion, index: number) {
    question.predefinedAnswers.splice(index, 1);
  }

  updateAnswerOrder(event: MoveEvent<ISurveyQuestionAnswer>) {
    const questionIndex = this.questions.findIndex(q => q.id === event.from.getAttribute('data-question-id'));
    if (questionIndex !== -1) {
      this.questions[questionIndex].predefinedAnswers.forEach((answer, index) => {
        answer.sort = index + 1;
      });
    }
  }

};
